<template>
    <div>
        <div class="form-group" v-if="prefijo==enumeraciones.etiquetasDeHTML.Select">
            <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
                <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un estatus de referencia</option>
                <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los estatus de referencia</option>
                <option v-for="tipoEstatusReferencia in EstatusReferencia" :value="tipoEstatusReferencia.TipoEstatusReferenciaId">{{tipoEstatusReferencia.Nombre}}</option>
            </select>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import axios from 'axios';
import api from '@/../static/js/api';
import comun from '@/../static/js/comun';

export default {
    data(){
        return {
            enumeraciones,
            comun,
            EstatusReferencia :[],
            idDelModelo: null
        }
    },
    props: {
        prefijo: Number,
        tipo: {
                Id: Number,
                Nombre: String 
            },
        idDelInput: String,
        valorDefinido: Number,
        parametros: Object
    },
    mounted() {
        if(this.valorDefinido == undefined || this.valorDefinido == null)
            {this.idDelModelo = this.tipo.Id;}
        else
            {this.idDelModelo = this.valorDefinido;}

        const parametros = {
            llave: this.idDelInput,
            valor: this.idDelModelo
        }
      
        this.$store.dispatch("A_ArchivoJudicial_Catalogo_Establecer014TipoEstatusReferencia", parametros);
    },
    methods: {
        cargaCatalogoTiposReferencia(){
            if(this.parametros == null || this.parametros == undefined)
                this.parametros = {}
            axios.post(api.conexion + api.ArchivoJudicial.TipoEstatusReferencia, this.parametros)
            .then(respuesta=> {
                if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {              
              this.EstatusReferencia = respuesta.data.TiposReferencia
              if(this.parametros.filtros !=undefined && this.parametros.filtros != null) {
                  this.EstatusReferencia = respuesta.data.EstatusReferencia.filter(cond=>this.parametros.filtros.some(tipo=>tipo.TiposReferencia.TipoEstatusReferenciaId));
              }    
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })   
        },
        cambiarDatos(evento) {
            this.idDelModelo = evento.target.value;
            const parametros = {
                llave: this.idDelInput,
                valor: evento.target.value
                }
            this.$store.dispatch("A_ArchivoJudicial_Catalogo_Establecer014TipoEstatusReferencia", parametros);
            this.$emit("valorParaElPadre", evento);
        }
    },
    created() {
            this.cargaCatalogoTiposReferencia();
        }
    }

</script>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/Catalogos/014TipoEstatusReferencia.vue